window.Events = new function()
{
    this.vars = {
        token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function() {
        jQuery('.create-edit-event-form').on('submit', function(event) {
            var start_date = jQuery(this).find('input[name="start_date"]').val();
            start_date     = new Date(start_date);
            var end_date   = jQuery(this).find('input[name="end_date"]').val();
            end_date       = new Date(end_date);
            var now        = new Date();

            if(end_date < start_date) {
                event.preventDefault();
                alert('End date must be after start date');
            }

            if(start_date < now) {
                event.preventDefault();
                alert('Event start date must be in the future');
            }
        });

        var event_type = jQuery('.create-edit-event-form select[name="event_type"] option:selected').val();
        if(event_type == '1') {
            jQuery('.create-edit-event-form div[data-event-type="1"]').show();
            jQuery('.create-edit-event-form div[data-event-type="2"]').hide();
        } else {
            jQuery('.create-edit-event-form div[data-event-type="1"]').hide();
            jQuery('.create-edit-event-form div[data-event-type="2"]').show();
        }

        jQuery('.create-edit-event-form').on('change', 'select[name="event_type"]', function() {
            var event_type = jQuery(this).val();
            if(event_type == '1') {
                jQuery('.create-edit-event-form div[data-event-type="1"]').show();
                jQuery('.create-edit-event-form div[data-event-type="2"]').hide();
            } else {
                jQuery('.create-edit-event-form div[data-event-type="1"]').hide();
                jQuery('.create-edit-event-form div[data-event-type="2"]').show();
            }
        });

        jQuery('body').on('click', '.accept-event-invite', function(event) {
            event.preventDefault();
            Events.acceptInvite(this);
        });

        jQuery('body').on('click', '.rsvp-yes', function(event) {
            event.preventDefault();
            Events.rsvpYes(this);
        });

        jQuery('body').on('click', '.decline-event-invite', function(event) {
            event.preventDefault();
            Events.declineInvite(this);
        });
    };

    /**
     * Accept an event invite
     *
     * @param obj el - accept button clicked
     */
    this.acceptInvite = function(el) {
        var event_id = jQuery(el).data('id');

        $.ajax({
            url: '/events/acceptinvite',
            type: 'POST',
            data: {
                event_id: event_id,
                _token: Events.vars.token
            },
            showloader: true,
            success: function(response) { 
                if(response == '1') {
                    jQuery(el).closest('.event-actions').remove();
                }
            }
        });
    };

    /**
     * RSVP yes to a public event
     *
     * @param obj el - rsvp yes button clicked
     */
    this.rsvpYes = function(el) {
        var event_id = jQuery(el).data('id');

        $.ajax({
            url: '/events/rsvpYes',
            type: 'POST',
            data: {
                event_id: event_id,
                _token: Events.vars.token
            },
            showloader: true,
            success: function(response) { 
                if(response == '1') {
                    jQuery(el).closest('.event-actions').remove();
                }
            }
        });
    };

    /**
     * Decline an event invite
     *
     * @param obj el - decline button clicked
     */
    this.declineInvite = function(el) {
        var event_id = jQuery(el).data('id');

        $.ajax({
            url: '/events/declineinvite',
            type: 'POST',
            data: {
                event_id: event_id,
                _token: Events.vars.token
            },
            showloader: true,
            success: function(response) { 
                if(response == '1') {
                    jQuery(el).closest('.event-actions').remove();
                }
            }
        });
    };
}

jQuery(document).ready(function($) {
    Events.init();
});
